<template>
	<ty-card>
		<div slot="header" class="ty-flex ty-space-between">
			<div class="ty-color-primary my-auto">{{label}}</div>
			<time-period-select v-model="period" />
		</div>
		<div style="height: 85px">
		</div>
	</ty-card>
</template>

<script>
	import TimePeriodSelect from '@/components/TimePeriodSelect.vue'
	export default {
		props: {
			types: {
				type: Array,
				default: () => [0, 1]
			},
			label: {
				type: String,
				default: 'آمار'
			},
			defaultOption: {
				type: Array,
				default: () => ['day', 30]
			}
		},
		components: {
			TimePeriodSelect
		},
		data() {
			const {
				defaultOption
			} = this;
			return {
				option: defaultOption,
				period: ['day', 30]
			}
		}
	}
</script>

<style>

</style>